// eslint-disable-next-line import/no-anonymous-default-export
export default {
    OperadorGestorAcessosOrgaoJurisdicionado: 1,
    OperadorAvancadoOrgaoJurisdicionado: 2,
    OperadorLeitorOrgaoJurisdicionado: 3,
    ServidorResponsavelPorComunicacoes: 4,
    ServidorResponsavelPorTriagemAcessosGestores: 5,
    ServidorResponsavelPorAdministrarTceComunica: 6,
    OperadorGestorOrgaoJurisdicionado: 99,
}